import React, { Component } from "react";
import { connect } from "react-redux";
import QuestionNumber from "../QuestionNumber";
import { nextQuestion } from "./../../actions/assessment";
import config from "./../../config/config-secret.json";

import axios from "axios";
import Webcam from "react-webcam";

let count = 0;

export class MultipleChoiceWithImageQuestion extends Component {
  constructor(props) {
    super(props);

    this.webcamRef = React.createRef();
  }

  componentDidMount() {
    count = 0;
    // SaveUserStateToServerHelper(this.props.assessment);
  }

  onUserMediaError = () => {
    alert("Can't access webcam, please contact administrator.");
  };

  onUserMedia = () => {};

  addCaptureImage = (imageb64, taken_at) => {
    axios
      .post(config.API_URL + `/administer_test/save_security_image/`, {
        imageb64,
        taken_at,
        tester_id: this.props.assessment.tester_id,
      })
      .catch((error) => {
        console.log(error);
      });
  };

  nextQuestion = async (id) => {
    if (count < 1) {
      count += 1;
      window.localStorage.setItem(
        this.props.assessment.key,
        JSON.stringify(this.props.assessment)
      );

      const { tester_id, ...last_session_info } = this.props.assessment;
      axios
        .post(config.API_URL + "/administer_test/update_tester_session_info/", {
          tester_id: tester_id,
          last_session_info: JSON.stringify(last_session_info),
        })
        .then((res) => {
          document.querySelector("#initloader").style.display = "none";
          this.props.nextQuestion(this.props.question_id, [id]);
        })
        .catch((error) => {
          document.querySelector("#initloader").style.display = "none";
          console.log(error);
          alert(
            "We are having issues sending the data to our server. Please check your internet connection and try to refresh your browser. If the issue persists, please contact your administrator."
          );
        });
    }
  };

  render() {
    let letter = "";
    // const IMG_POS_NONE = 0;
    // const IMG_POS_TOP = 1;
    // const IMG_POS_LEFT = 2;
    // const IMG_POS_RIGHT = 3;
    // const IMG_POS_BELOW = 4;

    return (
      <div className="question">
        {this.props.assessment.has_security_features && (
          <Webcam
            className="col-12 mb-4"
            style={{
              position: "absolute",
              right: "100%",
              display: "block",
            }}
            screenshotFormat="image/jpeg"
            muted={false}
            ref={this.webcamRef}
            onUserMediaError={this.onUserMediaError}
            onUserMedia={this.onUserMedia}
          />
        )}

        <div>
          <QuestionNumber />
          <p className="quesion-sub"></p>
        </div>

        {this.props.questionimage2 === null && (
          <div>
            <div className="row">
              <h4>
                <span
                  dangerouslySetInnerHTML={{ __html: this.props.questiontext }}
                ></span>
              </h4>
            </div>
            <div>
              <img
                src={this.props.questionimage1}
                alt="Question"
                className="img-fluid"
              />
            </div>
          </div>
        )}

        {this.props.questionimage2 !== null && (
          <div>
            {/* if image position is right */}
            {this.props.questionimage1_pos === 3 && (
              <div className="row">
                <div className="col-md-8 col-7">
                  <h4>
                    <span>{this.props.questiontext}</span>
                  </h4>
                </div>
                <div className="col-md-4 col-5">
                  <img
                    src={this.props.questionimage1}
                    alt="Question"
                    className="img-fluid"
                  />
                </div>
              </div>
            )}

            {/* if image position is below */}
            {this.props.questionimage1_pos === 4 && (
              <div>
                <h4>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: this.props.questiontext,
                    }}
                  ></span>
                </h4>

                <img
                  src={this.props.questionimage1}
                  alt="Question"
                  className="img-fluid mb3"
                />
              </div>
            )}

            <div className="mt-md-5">
              <img
                src={this.props.questionimage2}
                alt="Question"
                className="img-fluid"
              />
            </div>
          </div>
        )}

        <div className="choices-btn" data-toggle="buttons">
          {!!this.props.choices &&
            this.props.choices.map((value, index) => {
              if (letter === "") {
                letter = "A";
              } else {
                letter = String.fromCharCode(letter.charCodeAt(0) + 1);
              }

              return (
                <label
                  key={value.id}
                  className="btn btn-outline-light"
                  onClick={() => {
                    this.nextQuestion(value.id);

                    if (this.props.assessment.has_security_features) {
                      this.addCaptureImage(
                        this.webcamRef.current.getScreenshot(),
                        new Date()
                      );
                    }
                  }}
                >
                  <input
                    type="radio"
                    key={value.id}
                    id={"rdbChoice" + value.id}
                    name="choices"
                    value={value}
                    disabled
                  />

                  <span className="letter-choice">{letter}</span>
                  {!!value.choice.image && (
                    <img
                      src={config.API_DOMAIN + value.choice.image}
                      alt="Choice"
                    />
                  )}
                  {!!!value.choice.image && (
                    <span
                      className="break-all-text"
                      dangerouslySetInnerHTML={{ __html: value.choice.text }}
                    ></span>
                  )}
                </label>
              );
            })}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
});

const mapDispatchToProps = (dispatch) => ({
  nextQuestion: (question_id, choice_ids) =>
    dispatch(nextQuestion(question_id, choice_ids)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MultipleChoiceWithImageQuestion);
